export class SelectItem {

  id: any;
  name: string;
  description?: string;

}
